import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes:[
        {
            path:'/forword',
            component:  () => import('./../views/forword.vue'),
        },
        {
            path:'/badge',
            component:  () => import('./../views/badge.vue'),
        },
        {
            path:'',
            redirect:'forword'
        },
    ]
})